import React from "react";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { addLineBreake, replaceFormating } from "../../helper";


// --- single file download ---
const handleDownloadItem = async (file_url, file_name) => {
  try {
    // 1) fetch the file
    const res = await fetch(file_url);
    if (!res.ok) throw new Error("Network response was not ok");

    // 2) turn it into a blob
    const blob = await res.blob();

    // 3) make an object URL
    const url = window.URL.createObjectURL(blob);

    // 4) create a temporary link with download attr
    const link = document.createElement("a");
    link.href = url;
    link.download = file_name; // suggests the filename
    document.body.appendChild(link);
    link.click();

    // 5) clean up
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download failed:", err);
    // optionally show a user error toast
  }
};

/**
 * Return an icon component based on file extension or MIME type
 */
const getFileIcon = (fileName = "", fileType = "") => {
  const ext = fileName?.split?.(".")?.pop?.()?.toLowerCase?.() || "";

  if (["xls", "xlsx", "csv"].includes(ext)) {
    return <FileExcelOutlined className="text-green-600 text-xl" aria-hidden="true" />;
  }
  if (ext === "pdf") {
    return <FilePdfOutlined className="text-red-500 text-xl" aria-hidden="true" />;
  }
  if (["json", "txt", "md", "xml"].includes(ext) || fileType?.includes?.("text")) {
    return <FileTextOutlined className="text-gray-600 text-xl" aria-hidden="true" />;
  }
  return <FileUnknownOutlined className="text-gray-400 text-xl" aria-hidden="true" />;
};

/**
 * DocumentMessage
 *
 * Props:
 *  - fileName   (string): e.g. "report.xlsx"
 *  - fileSize   (string): human readable, e.g. "1.2 MB"
 *  - fileType   (string): MIME type, e.g. "application/vnd.ms-excel"
 *  - fileUrl    (string): download/open URL
 *  - isOwn      (bool):   right-align if true (sent), left-align if false (received)
 *  - onDownload (func):   optional callback when download icon is clicked
 *  - className  (string): extra wrapper classes
 */
export default function DocumentMessage({
  fileName = "",
  fileSize = "",
  fileType = "",
  fileUrl = "",
  fileCaption = "",
  isOwn = false,
  onDownload,
  className = "",
}) {
  const justify = isOwn ? "justify-end" : "justify-start";
  const bgColor = isOwn ? "bg-gray-100 bg-opacity-50" : "bg-[#dcf8c6]";

  return (
    <div className={`flex flex-col ${justify} ${className} min-w-[20vw] max-w-[20vw]`}>
      <div className={`flex items-center space-x-2 p-2 max-w-xs ${bgColor} rounded-lg`}>
        {/* File‐type icon */}
        <div className="flex-shrink-0">{getFileIcon(fileName, fileType)}</div>

        {/* File info */}
        <div className="flex-1 min-w-0">
          <p className="truncate font-medium">{fileName}</p>
          <div className="flex gap-2 text-xs text-gray-400">
            <span>{fileType?.toUpperCase?.()}</span>
            {fileSize && <span>. {fileSize}</span>}
          </div>
        </div>

        {/* Download action */}
        <a
          // href={fileUrl}
          // download={fileName}
          onClick={() => handleDownloadItem(fileUrl, fileName)}
          aria-label={`Download ${fileName}`}
          className="w-8 h-8 flex cursor-pointer items-center justify-center bg-transparent border border-gray-300 hover:border-gray-400 text-gray-600 hover:text-gray-800 rounded-full transition-colors duration-200"
        >
          <DownloadOutlined aria-hidden="true" />
        </a>
      </div>
      {fileCaption && (
        <div className="flex-1 min-w-0 mt-2 text-sm text-gray-500">
          <p className="font-medium" dangerouslySetInnerHTML={{
            __html: addLineBreake(
              replaceFormating(fileCaption)
            ),
            }}>
          </p>
        </div>
      )}
    </div>
  );
}
